const AppDownloadButtons = ({ onButtonClick }) => {
  return (
    <div className="flex w-full items-center justify-start gap-x-12">
      <div className="w-[109px]" onClick={() => onButtonClick('앱 스토어 - 앱 다운로드', null)}>
        <a
          target="_blank"
          href={'https://apps.apple.com/us/app/ringle-1-1-online-english/id1189876556'}
          className="text-reset lift mr-12 inline-block w-full"
          rel="noreferrer"
        >
          <img
            src="/assets/img/buttons/button-app.webp"
            alt="apple-logo-download"
            className="h-full w-full"
            loading="lazy"
          />
        </a>
      </div>
      <div className="w-[109px]" onClick={() => onButtonClick('구글플레이 스토어 - 앱 다운로드', null)}>
        <a
          target="_blank"
          href={'https://play.google.com/store/apps/details?id=com.ringle'}
          className="text-reset lift inline-block w-full"
          rel="noreferrer"
        >
          <img
            src="/assets/img/buttons/button-play.webp"
            alt="google-logo-download"
            className="h-full w-full"
            loading="lazy"
          />
        </a>
      </div>
    </div>
  )
}

export default AppDownloadButtons
